'use client';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { differenceInDays } from 'date-fns';

import cn from 'classnames';

import Button from '@/components/common/Button/Button';
import Text from '@/components/common/Text/Text';

import Arrows from 'public/img/icon/swipe-arrow-indicator.svg';

import './MobilePlansOverlay.style.scss';

type MobilePlansOverlayProps = {
  className?: string;
};

function MobilePlansOverlay(props: MobilePlansOverlayProps) {
  const { className = '' } = props;

  const [displayPlansOverlay, setDisplayPlansOverlay] =
    useState<boolean>(false);

  useEffect(() => {
    const plansOverlayDismissedDate =
      localStorage.getItem('plansOverlayDismissedDate') || '';
    const today = new Date().toDateString();

    if (
      !plansOverlayDismissedDate ||
      differenceInDays(new Date(plansOverlayDismissedDate), new Date(today)) <=
        -1
    ) {
      setDisplayPlansOverlay(true);
    }
  }, []);

  const handleOnClose = () => {
    localStorage.setItem(
      'plansOverlayDismissedDate',
      new Date().toDateString()
    );
    setDisplayPlansOverlay(false);
  };

  return (
    <>
      {displayPlansOverlay && (
        <div className={cn('MobilePlansOverlay', className)}>
          <div className='MobilePlansOverlay-content'>
            <Text
              italic={true}
              variant='title-l'
            >
              Swipe to see more memberships
            </Text>

            <Image
              className='MobilePlansOverlay-arrows'
              src={Arrows}
              alt=''
              height={30}
              width={64}
            />

            <Button
              onClick={handleOnClose}
              variant='light'
            >
              Got it
            </Button>
          </div>
        </div>
      )}
    </>
  );
}

export default MobilePlansOverlay;
